<template>
  <div class="associate-input">
    <div class="label">
      {{label}}：
    </div>
    <div class="chat-input">
      <ChatInput :value="value" @input="onInput" />
    </div>
    <div class="paragraph">
      <template v-for="(item, index) in paragraph">
        <p class="p" :key="index">{{item.text}}</p>
      </template>
    </div>
  </div>
</template>
<script>
import ChatInput from "@/components/AIChatting/ChatInput/index.vue";
export default {
  components: {
    ChatInput
  },
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    },
    paragraph: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      inputValue: "123",
      dateTimeValue: new Date()
    }
  },
  methods: {
    onInput (val) {
      this.$emit("input", val)
    }
  }
}

</script>

<style scoped lang="scss">
.label {
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 23px;
  color: rgba(59, 59, 59, 1);
  text-align: left;
  vertical-align: top;
  margin-bottom: 3px;
}
.chat-input {
  margin-bottom: 9px;
}
.paragraph {
  padding: 0 4px;
  box-sizing: border-box;
  p {
    font-size: 10px;
    font-weight: 400;
    line-height: 14.48px;
    color: rgba(121, 72, 234, 0.4);
    text-align: left;
    vertical-align: top;
  }
  p:last-child {
    margin-bottom: 0
  }
}
</style>